// Application configuration
const config = {
  // '/' = same origin (nginx proxies /api/ to Django in production)
  apiUrl: import.meta.env.VITE_API_URL || '/',
};

export default config;
